import { configureStore } from "@reduxjs/toolkit";
import productReducer from "../redux/stores/productSlice";

export const store = configureStore({
  reducer: {
    product: productReducer,
  },
});
